import { render, staticRenderFns } from "./CreateSet.vue?vue&type=template&id=7bf13ce9"
import script from "./CreateSet.vue?vue&type=script&lang=js"
export * from "./CreateSet.vue?vue&type=script&lang=js"
import style0 from "./CreateSet.vue?vue&type=style&index=0&id=7bf13ce9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports